<!-- Confirm component -->
<script>
import Orders from "../shared/components/orders/orders";
import TotalOrderCardWeb from "../shared/components/total-order-card-web/total-order-card-web.vue";
// import TotalOrderCard from "../shared/components/total-order-card/total-order-card.vue";
import Tabs from "../shared/components/tabs/tabs.vue";
import Loader from "../shared/components/loader/loader.vue";
import StoreHeader from "../shared/components/store-header/store-header.vue";
import StoreFooterMobile from "../shared/components/store-footer-mobile/store-footer-mobile.vue";
export default {
  components: {
    Orders,
    TotalOrderCardWeb,
    // TotalOrderCard,
    Tabs,
    Loader,
    StoreHeader,
    StoreFooterMobile
  },
  data: function() {
    return {
      extendPaymentDocker: false,
      paymentDone: false,
      managers: [],
      assignedManagers: {},
      number_format_locale: "en-CA",
      status: "",
      isLoading: false,
      loaded: false,
      paidFor: false,
      transactionId: null,
      points: 0,
      transaction: {
        total: "",
        points: ""
      },
      halfWidthPaymentDocker: false,
      paypalTransactionId: null
    };
  },
  created() {
    this.managers = this.$store.state.assignedManagers.managers;
    this.assignedManagers = this.$store.state.assignedManagers;
    this.transaction.points = this.assignedManagers.pointsTotal;
    this.transaction.total = this.assignedManagers.total;
    this.transactionId = this.$route.params.transactionId;
    this.number_format_locale = this.$store.state.userData.language == "en" ? "en-CA" : "fr-CA"
  },
  mounted: function() {
    const script = document.createElement("script");
    const currency = this.$store.getters.currency
    const payment_locale = `${this.$root.$i18n.locale}_CA`
    script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PAYPAL_CLIENT_ID}&currency=${currency}&locale=${payment_locale}`;
    script.addEventListener("load", this.setLoaded);
    document.body.appendChild(script);
  },
  methods: {
    setLoaded: function() {
      this.loaded = true;
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            console.log(data, actions)
            this.extendPaymentDocker = true;
            return fetch(process.env.VUE_APP_API_URL + "/Payments/Create", {
              method: "post",
              headers: {
                "content-type": "application/json"
              },
              credentials: "include",
              body: JSON.stringify({
                value: this.transaction.total,
                transaction_id: this.transactionId,
                points: this.transaction.points
              })
            })
              .then(function(res) {
                return res.json();
              })
              .then(function(data) {
                return data.orderID;
              });
          },
          onApprove: async (data, actions) => {
            this.isLoading = true;
            return fetch(process.env.VUE_APP_API_URL + "/Payments/Capture", {
              method: "post",
              headers: {
                "content-type": "application/json"
              },
              credentials: "include",
              body: JSON.stringify({
                orderID: data.orderID
              })
            })
            .then(async res => {
              this.status = res.status;
              let response = await res.json()
              if (response) {
                this.paypalTransactionId = response.transactionId
                if (this.status === 200) {
                  this.isLoading = false;
                  this.paymentDone = true;
                  this.$router.push(`/success/${response.transactionId}`)
                }
              }
              return response
            })
            .then(function(details) {
              if (details.error === "INSTRUMENT_DECLINED") {
                return actions.restart();
              }
            });
          },
          onError: () => {
            this.extendPaymentDocker = false;
          }
        })
        .render(this.$refs.paypal);
    },
    backPage() {
      if (!this.paymentDone) {
        this.$router.back();
      } else if (this.paymentDone) {
        this.$router.push(`/`);
      }
    },
    paymentDockerHandler() {
      (this.halfWidthPaymentDocker = !this.halfWidthPaymentDocker),
        (this.extendPaymentDocker = false);
    },
    payNow() {
      // this.extendPaymentDocker= true;
      this.halfWidthPaymentDocker = !this.halfWidthPaymentDocker;
    }
  },
  name: "confirm"
};
</script>

<!-- Template -->
<template>
  <fragment>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-md-12 offset-md-0 mobilepadall">
          <div>
            <div class="hide-on-mob">
              <!-- Store Header --Start -->
              <store-header @back="backPage" info="no" nextbtn="no"></store-header>
              <!-- Store Header --End -->
            </div>
            <div>
              <!-- Tabs -->
              <tabs
                tabTitle3="active"
                tabNumber3="active-number"
                border1="inactive-border"
                border2="inactive-border"
                border3="active-border"
              ></tabs>
              <!-- Tabs end -->
              <!--  payment page -->
              <div class="main-container">
                <div class="row">
                  <div class="col-md-6 pr-0">
                    <div class="confirm-container1">
                      <span class="summary-title1 nonebtn">{{ $tc("message.summaryTitle", 0) }}</span>
                      <orders
                        v-for="(manager, index) in managers"
                        :key="index"
                        :name="manager.name"
                        :points="manager.points"
                        :price="manager.price"
                      ></orders>
                    </div>
                  </div>
                  <div class="col-md-6 pl-0">
                    <div class="confirm-container2nd">
                      <div class="mb-5">
                        <span class="summary-title nonebtn">{{ $tc("message.summaryTitle", 1) }}</span>
                        <total-order-card-web
                          :subTotal="this.assignedManagers.subTotal"
                          :hst="this.assignedManagers.tax"
                          :service_fee="this.assignedManagers.service_fee"
                          :taxType="this.assignedManagers.taxType"
                          :taxValue="this.assignedManagers.tax"
                          :points="this.assignedManagers.pointsTotal"
                          :total="this.assignedManagers.total"
                          :number_format_locale="this.number_format_locale"
                        ></total-order-card-web>
                      </div>
                      <div
                        :class="[
                          halfWidthPaymentDocker ? 'blockbtn' : 'nonebtn',
                        ]"
                      >
                        <div
                          :class="[
                            extendPaymentDocker
                              ? 'payment-after-click payment'
                              : 'payment',
                          ]"
                          v-if="!isLoading"
                          class="paymentbottom"
                          ref="paypal"
                          target="_top"
                        >
                          <img
                            @click="paymentDockerHandler()"
                            class="arrowdownimg"
                            src="../../assets/DockerIcon.svg"
                            alt
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- payment page end -->
                </div>
              </div>
              <div class="mobileVisible">
                <store-footer-mobile @back="backPage" nextbtn="no" paybtn="yes" @payN="payNow"></store-footer-mobile>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoading">
      <loader></loader>
    </div>
  </fragment>
</template>



<!-- Style -->
<style lang="scss" scoped>
.confirm-supreme-container {
  background: #f8f8f8;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 0;
  margin-bottom: 50px;
}

.confirm-main-container {
  margin: 24px 30px;
  padding-bottom: 24px;
}
.confirm-container1 {
  background: #ffffff;
  padding: 24px;
  display: block;
  overflow: auto;
  margin-right: 12px;
  height: 65vh;
  max-height: 65vh;
  min-height: 65vh;
}
.confirm-container2nd {
  background: #ffffff;
  padding: 24px;
  margin-right: 0px;
  display: block;
  overflow: auto;
  margin-left: 12px;
  height: 65vh;
  max-height: 65vh;
  min-height: 65vh;
}

.confirm-container {
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 30px;
  height: 68vh;
  overflow: auto;
  display: inline-block;
  padding: 24px;
}

.summary-title1 {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  display: flex;
  align-items: center;
  color: #45505b;
  margin-bottom: 14px;
}

.summary-title {
  font-style: normal;
  font-weight: 500;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  display: flex;
  align-items: center;
  color: #45505b;
  margin-bottom: 40px;
}

.show-on-mob {
  display: none;
}
.payment {
  width: 100%;
  position: inherit;
}

@media (max-width: 600px) {
  .confirm-main-container {
    margin: 24px 10px;
  }
  .confirm-container1 {
    padding: 6px 20px;
    height: auto;
    max-height: auto;
    min-height: auto;
  }
  .confirm-container2nd {
    padding: 6px 20px;
    height: auto;
    max-height: auto;
    min-height: auto;
    width: 75%;
    float: right;
  }
  .confirm-container {
    width: 94%;
    position: relative;
    margin: 0 auto;
    border: none;
    padding: 0;
    display: block;
  }

  .show-on-mob {
    display: block;
  }

  .confirm-supreme-container {
    width: 100%;
    border: none;
    background-color: white;
  }

  .payment {
    position: absolute;
    margin: 110% auto 0 auto;
    bottom: 8%;
    width: 100%;
    padding: 20px;
    left: 0%;
    overflow: auto;
    max-height: 89vh;
    background: #fafbff;
  }

  .payment-after-click {
    margin: 0% auto 0 auto;
    top: 12%;
  }
  .payment-mobile {
    margin: 0% auto 0 auto;
    bottom: 8%;
    width: 100%;
    padding: 20px;
    left: 0%;
    overflow: auto;
    max-height: 100vh;
    background: #fafbff;
  }
  .paymentbottom {
    background: #fafbff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    padding: 43px 20px;
    padding-bottom: 0;
    padding-top: 20px;
    z-index: 9999999;
    overflow: auto;
  }

  .paymentbottomImg {
    position: fixed;
    bottom: 22%;
    left: 49%;
    z-index: 99999999;
  }

  .paymentbottomImg-after-click {
    position: fixed;
    top: 13.5%;
    bottom: 24.5%;
    left: 49%;
    z-index: 99999999;
  }
  .confirm-main-container {
    margin-top: 0 !important;
  }
  .blockbtn {
    display: block;
  }
  .nonebtn {
    display: none;
  }
  .total-order-card {
    position: absolute;
    width: 80%;
    height: 130px;
    right: 10px;
    margin-top: 40px;
  }
  .order-card {
    border-bottom: 2px solid #c1c8cf;
  }
  .sub-total-card {
    border-bottom: 2px solid #c1c8cf;
  }
}

@media (min-width: 601px) and(max-width:768px) {
  .confirm-container2 {
    left: 47%;
    width: 45%;
  }
  .confirm-container {
    width: 45%;
  }
}

@media (min-width: 768px) {
  .paymentbottomImg {
    display: none;
  }
}

@media (max-width: 320px) {
  .paymentbottomImg {
    bottom: 24%;
  }
}

@media (max-width: 360px) and (min-width: 321px) {
  .paymentbottomImg {
    bottom: 25%;
  }
}
@media (min-width: 370px) and (max-width: 375px) {
  .paymentbottomImg {
    bottom: 24.5%;
  }
}
@media (max-width: 540px) and (min-width: 500px) {
  .paymentbottomImg {
    bottom: 26%;
  }
}
@media (min-height: 730px) and (max-height: 731px) {
  .paymentbottomImg {
    bottom: 22.5%;
  }
}
@media (min-height: 800px) and (max-height: 823px) {
  .paymentbottomImg {
    bottom: 19.5%;
  }
}
@media (min-width: 1800px) {
  .confirm-container2 {
    left: 49.77%;
  }
  .payment {
    left: 52.55%;
  }
  .confirm-container {
    left: 0.5%;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .payment {
    bottom: 37%;
  }
}
</style>
